module.exports = __webpack_public_path__ + "static/media/liikkuminen.0998bd1d.jpg";